module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1102.9197bc43.jpg";